import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import {
  InfiniteScroll,
  SearchComponent,
  TitleWithArrowLink,
} from "../../../../components";
import { EndPoints } from "../../../../Constants/endpoints";
import { CardWithIconSkeleton } from "../../../../Share";
import { SearchDrugCard } from "../component";

import EmptyIcon from "../../../../assets/images/icons/Medication.svg";

function Medications({ className }: { className?: string }) {
  const { id } = useParams();
  const { t } = useTranslation();
  const [drugsData, setDrugsData] = useState<any[]>();
  const [searchTerm, setSearchTerm] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");
  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearch(searchTerm);
    }, 500);
    return () => clearTimeout(timer);
  }, [searchTerm]);
  return (
    <div className={`flex flex-col gap-4 ${className}`}>
      {className && <TitleWithArrowLink title="medication" />}
      <div className="flex flex-wrap items-center justify-between gap-4">
        <h3 className="mb-2 mt-8 text-sm font-semibold">
          {t("all_medications")}
        </h3>
        <SearchComponent
          searchOn="typing"
          placeholder={t("search_for_medications")}
          showSearchHistory={false}
          className="max-xs:w-full lg:w-[28rem]"
          onSearch={(value) => setSearchTerm(value)}
        />
      </div>
      <div
        className={`grid gap-4 rounded-lg ${(drugsData?.length ?? 0) > 0 ? "bg-Gray" : ""} p-3 max-lg:grid-cols-2 max-sm:grid-cols-1 xl:grid-cols-2 xxl:grid-cols-3`}
      >
        {(drugsData?.length ?? 0) > 0 &&
          drugsData?.map((e, index) => <SearchDrugCard key={index} item={e} />)}
        <InfiniteScroll
          Count={8}
          skeletonCount={8}
          endpoint={EndPoints.GetPatientDrug + "/" + id}
          getAllParams={{
            Name: debouncedSearch,
          }}
          getData={(data) => setDrugsData(data)}
          renderSkeleton={<CardWithIconSkeleton />}
          noDataElement={
            <div className="flex h-[34vh] flex-col items-center justify-center gap-4 lg:w-[36%]">
              <img alt="empty" className="w-24 opacity-70" src={EmptyIcon} />
              <h4 className="text-center text-body-text">{t("no_data_yet")}</h4>
            </div>
          }
        />
      </div>
    </div>
  );
}

export default Medications;
